<template>
    <div id="loading-spinner">
      <div class="spin-icon"></div>
    </div>
</template>
  <script>
  import router from "@/routes";
  import { eventBus } from "@/main";
  export default {
    props: ["test"],
    data() {
      return {
        urlData: {
          token: this.$router.currentRoute.params.token,
        }
      };
    },
    mounted() {
      let vm = this;
      
      this.$store.dispatch("ClasseraLogin", this.urlData).then(
        response => {

            
        },

        error => {
          router.push({
                          path: '/',
                          query: { lang: this.$route.query.lang }
                          }); 
          console.log(error);
        }
      );
    }
  };
  </script>
  <style scoped>
  #loading-spinner {
    display: inline;
    position: relative;
    z-index: 999999;
  }
  
  #loading-spinner .spin-icon {
    margin: auto;
    width: 80px;
    height: 80px;
    margin-top: 18%;
    border: solid 3px transparent;
    border-top-color: #001f5b;
    border-left-color: #49c1df;
    border-radius: 80px;
  
    -webkit-animation: loading-spinner 500ms linear infinite;
    -moz-animation: loading-spinner 500ms linear infinite;
    -ms-animation: loading-spinner 500ms linear infinite;
    -o-animation: loading-spinner 500ms linear infinite;
    animation: loading-spinner 500ms linear infinite;
  }
  
  @-webkit-keyframes loading-spinner {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  
  @-moz-keyframes loading-spinner {
    0% {
      -moz-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -moz-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  
  @-o-keyframes loading-spinner {
    0% {
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  
  @-ms-keyframes loading-spinner {
    0% {
      -ms-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -ms-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  
  @keyframes loading-spinner {
    0% {
      transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/main/classera.vue